
import { defineComponent, PropType, computed } from '@vue/composition-api';
import StoryblokVideo from '~/components/storyblok/Video/Video.vue';
import FCImage from '~/components/FCImage.vue';
import { transformShortTextContent, transformPictureResponsiveContent } from '~/selectors/selectors';
import { IStoryblokPictureResponsive, IStoryblokShortText, IStoryblokVideo } from '~/selectors/types';

export default defineComponent({
  name: 'MediaWithHeadlineText',
  components: {
    FCImage,
    StoryblokVideo,
  },
  inheritAttrs: false,
  props: {
    headline: {
      type: Array as PropType<IStoryblokShortText[]>,
      default: () => ([]),
    },
    text: {
      type: Array as PropType<IStoryblokShortText[]>,
      default: () => ([]),
    },
    media: {
      type: Array as PropType<(IStoryblokPictureResponsive | IStoryblokVideo)[]>,
      default: () => ([]),
    },
    aspectRatio: {
      type: String,
      default: 'square',
    },
  },
  setup(props) {
    const aspectClass = computed(() => {
      switch (props.aspectRatio) {
      case 'portrait':
        return 'aspect-portrait';
      case 'landscape':
        return 'aspect-landscape';
      case 'square':
      default:
        return 'aspect-square';
      }
    });

    const textContent = computed(() => transformShortTextContent(props.text[0]));
    const headlineComponentProps = computed(() => transformShortTextContent(props.headline[0]));

    const mediaProps = computed(() => {
      if (props.media[0]?.component === 'PictureResponsive') {
        return {
          component: 'PictureResponsive',
          rounded: props.media[0]?.rounded,
          nuxtImageProps: transformPictureResponsiveContent(props.media[0]),
        };
      }

      return props.media[0];
    });

    return {
      textContent,
      aspectClass,
      headlineComponentProps,
      mediaProps,
      isVideo: computed(() => mediaProps.value.component === 'Video'),
    };
  },
});
